// @flow
import { PDFFillerContext } from 'pages/Contexts/PdfFillerContext'
import * as React from 'react'
import SelectField from 'ui/molecules/SelectField'

const fontSizes = [
  { value: 'auto' },
  { value: '8' },
  { value: '9' },
  { value: '10' },
  { value: '11' },
  { value: '12' },
  { value: '14' },
  { value: '16' },
  { value: '18' },
  { value: '20' },
  { value: '24' },
  { value: '28' },
  { value: '32' },
  { value: '48' },
  { value: '60' },
  { value: '72' },
  { value: '96' },
]

function InputSettingsPanelFontSizeField(): React.Node {
  const {
    inputFields,
    lastAppliedSettings,
    selectedInputFieldId,
    setInputFields,
    setLastAppliedSettings,
  } = React.useContext(PDFFillerContext)

  const inputField = selectedInputFieldId
    ? inputFields[selectedInputFieldId]
    : null

  const onChange = React.useCallback(
    (event) => {
      event.persist()

      if (!selectedInputFieldId || !inputField) return

      setInputFields((previousInputFields) => {
        return {
          ...previousInputFields,
          [selectedInputFieldId]: {
            ...previousInputFields[selectedInputFieldId],
            font_size: event.target.value,
          },
        }
      })

      lastAppliedSettings[inputField.input_type] = lastAppliedSettings[
        inputField.input_type
      ] || { height: inputField.height, width: inputField.width }

      lastAppliedSettings[inputField.input_type].font_size = event.target.value

      setLastAppliedSettings(lastAppliedSettings)
    },
    [
      inputField,
      lastAppliedSettings,
      selectedInputFieldId,
      setInputFields,
      setLastAppliedSettings,
    ]
  )

  if (!inputField) return null

  return (
    <SelectField
      semibold
      label="Font Size"
      onChange={onChange}
      options={fontSizes}
      value={inputField.font_size}
    />
  )
}

export default InputSettingsPanelFontSizeField
